import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import InsightDetailPage from "../pages/insights/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/insights/:slug",
    element: <InsightDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;